import { Children, isValidElement, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './SidebarNavigation.module.scss';

export interface SidebarNavigationProps {
    /** Navigation items */
    children: ReactNode;
    /** Additional CSS class */
    className?: string;
    /** Accessible label for the navigation */
    ariaLabel?: string;
}

export default function SidebarNavigation(props: SidebarNavigationProps) {
    const { children, className, ariaLabel } = props;
    const { t } = useTranslation();

    // A list may only hold list items, so each entry (nav item, back link, divider, logo link)
    // gets its own. `toArray` drops the `false` and `null` of conditional entries and gives
    // every element a key.
    return (
        <nav
            className={cn(styles.navigation, className)}
            aria-label={ariaLabel ?? t('layout.sidebar.mainNavigation')}>
            <ul className={styles.list}>
                {Children.toArray(children)
                    .filter(isValidElement)
                    .map((child) => (
                        <li key={child.key} className={styles.item}>
                            {child}
                        </li>
                    ))}
            </ul>
        </nav>
    );
}
